import { removeHashFromUrl } from './removeHashFromUrl.js';

/**
 * Adds hash after name and version in a URL.
 * If hash already exists, replaces it.
 *
 * @param params - Parameters for adding hash to URL
 * @param params.url - URL to add hash to
 * @param params.packageName - Package name
 * @param params.version - Package version
 * @param params.hash - Hash to add
 * @returns URL with hash added or replaced
 *
 * @example
 * ```ts
 * addHashUrl({
 *   url: 'http://localhost:3000/react@17.5.0/v0/bundled/index.js',
 *   packageName: 'react',
 *   version: '17.5.0',
 *   hash: 'abc123'
 * });
 * // Returns: 'http://localhost:3000/react@17.5.0/h-abc123/v0/bundled/index.js'
 * ```
 */
export function addHashUrl(params: {
  /** URL to add hash to */
  url: string;
  /** Package name */
  packageName: string;
  /** Package version */
  version: string;
  /** Hash to add */
  hash: string;
}): string {
  const { url, packageName, version, hash } = params;
  const packageId = `${packageName}@${version}`;
  const packageUrlIndex = url.indexOf(packageId);
  if (packageUrlIndex !== -1) {
    const hashIndex = packageUrlIndex + packageId.length;
    const urlWithoutHash = removeHashFromUrl(url);
    return urlWithoutHash.slice(0, hashIndex) + `/h-${hash}` + urlWithoutHash.slice(hashIndex);
  }
  return url;
}
